import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { RotateCcw, Shield, Clock, AlertCircle } from "lucide-react";

const ReturnsTab: React.FC = () => {
  return (
    <div className="relative space-y-6 pointer-events-auto">
      <Card>
        <CardContent className="relative z-10 p-6">
          <div className="flex items-center gap-3 mb-4">
            <RotateCcw className="h-5 w-5 text-primary" />
            <h3 className="text-lg font-semibold">Return Policy</h3>
          </div>
          <div className="space-y-4">
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
              <Clock className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">30-Day Return Window</p>
                <p className="text-sm text-muted-foreground">
                  You have 30 days from delivery to return your item
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
              <Shield className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">Easy Returns</p>
                <p className="text-sm text-muted-foreground">
                  Free return shipping with prepaid return label
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="relative z-10 p-6">
          <h3 className="text-lg font-semibold mb-4">Return Requirements</h3>
          <div className="space-y-3 text-sm">
            <p>• Items must be in original condition with tags attached</p>
            <p>• Include original packaging and any accessories</p>
            <p>• Items must be unworn and unwashed</p>
            <p>• Refunds processed within 5-7 business days</p>
            <p>• Custom or personalized items cannot be returned</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="relative z-10 p-6">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-amber-500 mt-0.5" />
            <div>
              <h4 className="font-medium mb-2">Need Help?</h4>
              <p className="text-sm text-muted-foreground mb-3">
                Contact our customer service team for assistance with your return.
              </p>
              <p className="text-sm">
                <strong>Email:</strong> returns@example.com<br />
                <strong>Phone:</strong> 1-800-123-4567
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReturnsTab;